import { useTranslation } from "react-i18next";

export default function AboutSection() {
  const { t } = useTranslation();

  const points = [
    { icon: "ri-file-list-3-line", key: "organized" },
    { icon: "ri-scales-3-line", key: "compare" },
    { icon: "ri-refresh-line", key: "updated" },
  ];

  return (
    <section className="bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("home.about.title")}
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {t("home.about.subtitle")}
          </p>
        </div>

        <div className="mx-auto mt-8 max-w-3xl space-y-4 text-base leading-relaxed text-foreground-600">
          <p>{t("home.about.p1")}</p>
          <p>{t("home.about.p2")}</p>
        </div>

        <div className="mx-auto mt-10 grid max-w-4xl grid-cols-1 gap-4 sm:grid-cols-3">
          {points.map((point) => (
            <div
              key={point.key}
              className="rounded-xl border border-background-200 bg-white p-5"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className={`${point.icon} text-lg`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 text-sm font-semibold text-foreground-900">
                {t(`home.about.points.${point.key}.title`)}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-500">
                {t(`home.about.points.${point.key}.desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}